// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__V0xq3","vLegacy":"SelectSecondary_vLegacy__2Yi1Z","error":"SelectSecondary_error__1TURp","disabled":"SelectSecondary_disabled__qHpNg"};